























import { defineComponent, ref } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import QuestionDetail from '@/components/organisms/questionnaire/QuestionDetail.vue'
import { useUser } from '@/composable/common/useUser'
import { QuestionForm } from '@/composable/questionnaire/useQuestionForm'
import { useActions } from 'vuex-composition-helpers'
import { QuestionnaireActions } from '@/store/questionnaire/actions'

export default defineComponent({
  name: 'CreateQuestion',
  components: { Layout, QuestionDetail },
  setup(props, context) {
    const { user } = useUser(context)
    const pageId = context.root.$route.params.pageId
    const questionnarieId = context.root.$route.params.id

    const { createQuestion } = useActions<QuestionnaireActions>(
      'questionnaire',
      ['createQuestion'],
    )

    const snackbar = ref({
      snackbar: false,
      message: '',
    })

    const save = async (body: QuestionForm) => {
      try {
        await createQuestion({ ...body, pageId: parseInt(pageId) })
        const qType = /automatic/.test(context.root.$route.path)
          ? 'automatic'
          : 'manual'
        context.root.$router
          .push(`/${qType}/${questionnarieId}/detail`)
          .catch(() => {
            /*2連打した際のerrorを無視*/
          })
      } catch {
        snackbar.value.snackbar = true
        snackbar.value.message = 'エラーが発生しました。'
      }
    }

    const cancel = () => {
      const qType = context.root.$route.path.includes('automatic')
        ? 'automatic'
        : 'manual'
      context.root.$router
        .push(`/${qType}/${questionnarieId}/detail`)
        .catch(() => {
          /*2連打した際のerrorを無視*/
        })
    }

    return {
      user,
      snackbar,
      save,
      cancel,
    }
  },
})
